import { 
 FaGithub,  
  FaLinkedinIn, 
  FaFacebookF, 
  FaInstagram, 
  FaTiktok, 
  FaEnvelope, 
  FaPhoneAlt, 
  FaMapMarkerAlt,
  FaWhatsapp // <--- تأكد من إضافة هذه الكلمة هنا
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import "./Footer.css";

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <motion.div 
        className="footer-container"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="footer-main-grid">
          
          {/* القسم الأول: اللوجو والوصف */}
          <div className="footer-section about-footer">
            <div className="footer-branding">
              <img src="logo.png" alt="Ziad Logo" className="footer-main-logo" />
              <div className="footer-logo-text">
                Ziad<span>hamada</span>
              </div>
            </div>
            <p className="footer-text">
              {t('footer_desc') || "مطور واجهات أمامية متخصص في بناء تجارب رقمية تفاعلية واحترافية باستخدام أحدث التقنيات."}
            </p>
          </div>

          {/* القسم الثاني: روابط سريعة */}
          <div className="footer-section links-footer">
            <h4>{t('quick_links') || "روابط سريعة"}</h4>
            <ul>
              <li><a href="#about">{t('nav_about')}</a></li>
              <li><a href="#projects">{t('nav_projects')}</a></li>
              <li><a href="#contact">{t('nav_contact') || "تواصل معي"}</a></li>
            </ul>
          </div>

          {/* القسم الثالث: معلومات التواصل */}
          <div className="footer-section contact-footer">
            <h4>{t('contact_info') || "معلومات التواصل"}</h4>
            <div className="contact-item">
              <FaEnvelope /> <span>hziad5940@gmail.com</span>
            </div>
            <div className="contact-item">
              <FaPhoneAlt /> <span>01204964891</span>
            </div>
            <div className="contact-item">
              <FaMapMarkerAlt /> <span>Alexandria, Egypt</span>
            </div>
          </div>

        </div>

        {/* السوشيال ميديا - الروابط الفعلية فقط */}
        <div className="footer-social-wrapper">
          <div className="social-links">
            {[
              { 
                icon: <FaFacebookF />, 
                link: "https://www.facebook.com/share/1Crq4Wnzfu/?mibextid=wwXIfr" 
              },
              { 
                icon: <FaInstagram />, 
                link: "https://www.instagram.com/ziad_hamada_9?igsh=MTZhY3NobTl5a3BueA%3D%3D&utm_source=qr" 
              },
              { 
                icon: <FaTiktok />, 
                link: "https://www.tiktok.com/@ziad_hamada0?_r=1&_t=ZS-95qUW9qo360" 
              },
              { 
                icon: <FaLinkedinIn />, 
                link: "https://www.linkedin.com/in/ziad-hamada-793046406?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" 
              },
              { 
                icon: < FaGithub />, 
                link: "https://github.com/ziad-hamada" // تأكد من وضع رابط الجيتهاب الخاص بك هنا
              },
              { 
  icon: <FaWhatsapp />, 
  link: "https://wa.me/201204964891" 
},
            
            ].map((social, index) => (
              <motion.a 
                key={index}
                href={social.link} 
                target="_blank" 
                rel="noopener noreferrer"
                whileHover={{ scale: 1.2, y: -5, color: "var(--primary-color)" }}
                whileTap={{ scale: 0.9 }}
              >
                {social.icon}
              </motion.a>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Ziad Hamada. All rights reserved.</p>
        </div>
      </motion.div>
    </footer>
  );
}